<app-header #header title="deductions-form"></app-header>


<ion-content [appHideHeader]="header" class="ionic_background">
  <h2 class="subheader-bold" style="text-align: center;">
    {{ ('keys.data.users_menu.custom_deductions' |
              translate : {Default:'Deductions Form'}) || 'Deductions Form' }}
  </h2>
 <ion-card class="card-shadow-7">
 <ion-card-content>
  <form *ngIf="dataSRV.user" [formGroup]="deductionsForm" (ngSubmit)="onSubmit()">
   
  
<ion-grid>
  <ion-row>
    <ion-col>
      
    </ion-col>
  </ion-row>
<ion-row>
  <ion-col>
   <ion-card class="card-shadow-3">
    <ion-item>
      <ion-label>
        Employee Name (Print): {{ dataSRV.user['firstName']}} {{dataSRV.user['lastName']}} 
      </ion-label>
   
    </ion-item>
   </ion-card>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <ion-card class="card-shadow-3">
    <ion-item>
      <ion-label>
        R 
      </ion-label>
      <ion-input
          formControlName="spriden_id"
          placeholder="Tech ID"
        ></ion-input>
    </ion-item>
  </ion-card>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    
    <div >Status</div>
    <ion-card class="card-shadow-3">
      <ion-radio-group formControlName="status">
        <ion-item>
          <ion-label>Activate</ion-label>
          <ion-radio slot="end" value="activate"></ion-radio>
        </ion-item>
        <ion-item>
          <ion-label>Change</ion-label>
          <ion-radio slot="end" value="change"></ion-radio>
        </ion-item>
        <ion-item>
          <ion-label>Terminate</ion-label>
          <ion-radio slot="end" value="terminate"></ion-radio>
        </ion-item>
      </ion-radio-group>
  </ion-card>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <h2 class="subheader-regular" >
      Check all that apply:
    </h2>
    <ion-item lines="none">
  <ion-label>Pre-tax - Payroll deductions will take place before taxes are paid.</ion-label>
</ion-item>
  <ion-label>After-tax - Payroll deductions will take place after taxes have been deducted.</ion-label>

  <!-- Checkboxes -->
  <ion-card class="card-shadow-3">
    <ion-item>
      <ion-checkbox
        slot="start"
        [checked]="deductionsForm.get('ph_tax').value.includes('ph1')"
        (ionChange)="onCheckboxChange($event, 'ph1')"
      ></ion-checkbox>
      <ion-label>PH1 Monthly pre-tax</ion-label>
    </ion-item>
    <ion-item>
      <ion-checkbox
        slot="start"
        [checked]="deductionsForm.get('ph_tax').value.includes('ph2')"
        (ionChange)="onCheckboxChange($event, 'ph2')"
      ></ion-checkbox>
      <ion-label>PH2 Monthly after-tax</ion-label>
    </ion-item>
    <ion-item>
      <ion-checkbox
        slot="start"
        [checked]="deductionsForm.get('ph_tax').value.includes('ph3')"
        (ionChange)="onCheckboxChange($event, 'ph3')"
      ></ion-checkbox>
      <ion-label>PH3 Semi-monthly pre-tax</ion-label>
    </ion-item>
    <ion-item>
      <ion-checkbox
        slot="start"
        [checked]="deductionsForm.get('ph_tax').value.includes('ph4')"
        (ionChange)="onCheckboxChange($event, 'ph4')"
      ></ion-checkbox>
      <ion-label>PH4 Semi-monthly after-tax</ion-label>
    </ion-item>
  </ion-card>
  
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <h2 class="subheader-regular" >Will the registered vehicle require use of an electrical charge station?</h2>
    <ion-card class="card-shadow-3">
      <ion-radio-group formControlName="electric_vehicle">
        <ion-item>
          <ion-label>Yes</ion-label>
          <ion-radio slot="end" value="yes"></ion-radio>
        </ion-item>
        <ion-item>
          <ion-label>No</ion-label>
          <ion-radio slot="end" value="no"></ion-radio>
        </ion-item>
      </ion-radio-group>
      </ion-card>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <ion-label>I certify that Parking & Transportation Services has authorization to commence parking deductions as noted above.</ion-label>

    <ion-label>I understand it is my responsibility to inform Parking & Transportation Services of any changes to my parking
        deduction. (i.e. moving off campus or no longer requiring parking accommodations)</ion-label>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <ion-card class="card-shadow-3">
   <ion-item>
    <ion-label position="floating">
      Employee Signature
    </ion-label>
    <ion-input
    formControlName="employee_deduction_consent"
    placeholder="Employee Signature"
  ></ion-input>
   </ion-item>
  </ion-card>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <ion-card class="card-shadow-3">
    <ion-item id="employee_consent_date">
      <ion-label >
        Date
      </ion-label>
      <ion-label  slot="end">
        {{deductionsForm.value['employee_consent_date'] |
        date:dataSRV.settings['system']['datemask'] }}
      </ion-label>
    </ion-item>
  </ion-card>
    <ion-popover trigger="employee_consent_date" size="cover">
      <ng-template>
        <ion-datetime
          size="cover"
          max="2123-05-25T10:19:04.840-07:00"
          [showDefaultButtons]="true"
          presentation="date"
          formControlName="employee_consent_date"
          display-format="MMM DD, YYYY"
        ></ion-datetime>
      </ng-template>
    </ion-popover>
    
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <p>Parking policies may be reviewed at:</p>
    <ul>
      <li>
        <ion-item style="cursor: pointer;" clickable (click)="openPDF('https://elpaso.ttuhsc.edu/opp/_documents/76/op7630.pdf')">
          <ion-label>Vehicle Registration</ion-label>
        </ion-item>
      </li>
      <li>
        <ion-item style="cursor: pointer;" clickable (click)="openPDF('https://elpaso.ttuhsc.edu/opp/_documents/76/op7632a.pdf')">
          <ion-label>Traffic & Parking Regulations</ion-label>
        </ion-item>
      </li>
    </ul>
  </ion-col>
</ion-row>
<!-- <ion-row>
  <ion-col>
      <h3>Section Below for Parking & Transportation Services Use Only</h3>
      <ion-card class="card-shadow-3">
      <h4>Parking Space - Check One</h4>
          <ion-radio-group formControlName="zone">
            <ion-item *ngFor="let zone of zones">
              <ion-label>  {{ zone.label }} ({{ zone.price }}/month)</ion-label>
              <ion-radio slot="end" [value]="zone.value"></ion-radio>
            </ion-item>
          </ion-radio-group>
          <ion-note style="margin-top: 2em;">*Canopy reserved parking rate: Permit holder to be assessed up to an additional 20% fee per month based on parking zone</ion-note>
      </ion-card>
     
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    

                <hr>

                <ion-label>I certify that the department has received from the employee identified above written voluntary authorization to take the deduction identified.</ion-label>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <ion-card class="card-shadow-3">
   <ion-item>
    <ion-label position="floating">
      Parking Office
    </ion-label>
    <ion-input
    formControlName="department_received_confirm"
    placeholder="Parking Office Confirmation"
  ></ion-input>
   </ion-item>
  </ion-card>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <ion-card class="card-shadow-3">
    <ion-item id="department_received_date">
      <ion-label>
        Date
      </ion-label>
      <ion-label  slot="end">
        {{deductionsForm.value['department_received_date'] |
        date:dataSRV.settings['system']['datemask'] }}
      </ion-label>
    </ion-item>
  </ion-card>
    <ion-popover trigger="department_received_date" size="cover">
      <ng-template>
        <ion-datetime
          size="cover"
          max="2123-05-25T10:19:04.840-07:00"
          [showDefaultButtons]="true"
          presentation="date"
          formControlName="department_received_date"
          display-format="MMM DD, YYYY"
        ></ion-datetime>
      </ng-template>
    </ion-popover>
    
  </ion-col>
</ion-row> -->
<ion-row>
  <ion-col>
    <div >
      <div >
        <ion-button  [disabled]="!deductionsForm.valid " expand="block" type="submit">
          Submit Form
        </ion-button>
      </div>
    </div>
  </ion-col>
</ion-row>
<ion-row>
  
</ion-row>
</ion-grid>
</form>
 </ion-card-content>
 </ion-card>
</ion-content>

